import { FC } from 'react';
import s from './Version.module.css';
import { useTranslation } from 'react-i18next';

export const Version: FC = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className={s.version}>
                {t('version')}: {process.env.REACT_APP_VERSION}
            </div>
        </>
    );
};
